import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';

interface ClaimTreatmentsTabsProps {
  activeTab: 'all' | 'warnings';
  allCount: number;
  onTabChange: (tab: 'all' | 'warnings') => void;
  warningCount: number;
}

export const ClaimTreatmentsTabs = ({
  activeTab,
  allCount,
  onTabChange,
  warningCount,
}: ClaimTreatmentsTabsProps) => {
  const { t } = useLingui();
  const items = [
    {
      count: warningCount,
      label: t`Warnings Only`,
      value: 'warnings' as const,
    },
    {
      count: allCount,
      label: t`All Treatments`,
      value: 'all' as const,
    },
  ];

  return (
    <div className="vai-flex vai-border-b vai-border-zinc-800">
      {items.map((item) => (
        <button
          key={item.value}
          className={classNames(
            'vai-border-b-2 vai-px-3 vai-py-[14px] vai-text-[14px] vai-leading-5',
            {
              'vai-border-blue-500 vai-text-zinc-50': activeTab === item.value,
              'vai-border-transparent vai-text-zinc-400':
                activeTab !== item.value,
            },
          )}
          onClick={() => onTabChange(item.value)}
          type="button"
        >
          {`${item.label} (${item.count})`}
        </button>
      ))}
    </div>
  );
};
